import { createTranslatedText } from '@dreryk/react-common';
import { NumberInput } from '@dreryk/react-components';

import { answerToFormValue } from '../../tab/MedicalProfileAnswer.utils';
import {
   DetailQuestionViewModel,
   FieldScope,
   MedicalProfileTabFormController,
} from '../../tab/MedicalProfileTab.types';
import { createFormFieldName } from '../../tab/MedicalProfileTab.utils';

type NumberFieldProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly question: DetailQuestionViewModel;
   readonly disabled: boolean;
   readonly scope?: FieldScope;
};

export const NumberField = (props: NumberFieldProps): JSX.Element => {
   return (
      <NumberInput
         testId={`detailQuestion-${props.question.questionId}`}
         label={createTranslatedText(props.question.content)}
         controller={props.register(createFormFieldName(props.templateCode, props.question.questionId, props.scope))}
         defaultValue={answerToFormValue(props.question.answerType, props.question.existingAnswer) as number | null}
         min={props.question.config?.minValue}
         max={props.question.config?.maxValue}
         precision={props.question.config?.decimals}
         disabled={props.disabled}
         required={props.question.required}
         horizontal
      />
   );
};
